/* Label lookup for the three strings this painter writes itself. A section may publish
   window.ASPD_I18N = { save: '...', subSave: '...', addToCart: '...' } to translate them;
   with nothing published, every fallback is the exact string that used to be hardcoded. */
function aspdWord(k, fallback){
  var d = window.ASPD_I18N;
  return (d && typeof d[k] === 'string' && d[k].length) ? d[k] : fallback;
}
/* AstraHelvetia — AstraSleep product page interactions (editable OS2.0 build).
   Ported from the original DCLogic port, made theme-editor safe:
   - single init guard
   - per-element bind flags so re-boot on shopify:section:load never double-binds
   - Shopify.designMode reveals content immediately (never invisible while editing)
   Cart wired to Shopify via window.ASPD_VARIANTS (m1/m3/m6 -> variant ids),
   prices (integer cents) via window.ASPD_PRICES, formatted with the shop money
   format via window.ASPD_MONEY_FORMAT (money() → matches store currency). */
(function () {
  if (window.__aspdInit) return;
  window.__aspdInit = true;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  var App = {
    variant: 'm3', plan: 'sub', qty: 1, tIndex: 0,
    // prices are INTEGER CENTS (matches window.ASPD_PRICES); formatted for display via money()
    prices: { m1: { once: 2999, orig: 4900 }, m3: { once: 6999, orig: 14000 }, m6: { once: 14999, orig: 25250 } },
    moneyFormat: '€{{amount_with_comma_separator}}', subPct: 15, redirect: '/checkout', subCode: '',

    q: function (s) { return document.querySelector(s); },
    qa: function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); },
    set: function (s, t) { var el = this.q(s); if (el) el.textContent = t; },

    boot: function () {
      if (window.ASPD_PRICES) this.prices = window.ASPD_PRICES;
      if (window.ASPD_MONEY_FORMAT) this.moneyFormat = window.ASPD_MONEY_FORMAT;
      if (window.ASPD_SUBPCT != null && !isNaN(window.ASPD_SUBPCT)) this.subPct = +window.ASPD_SUBPCT;
      if (window.ASPD_REDIRECT) this.redirect = window.ASPD_REDIRECT;
      if (window.ASPD_SUB_CODE != null) this.subCode = window.ASPD_SUB_CODE;
      // packs per option (1-pack=1, 3-pack=3, 6-pack=6): the cart line gets this many physical units so fulfillment ships the right count
      this.packUnits = window.ASPD_PACK_UNITS || { m1: 1, m3: 3, m6: 6 };
      // Optional per-section starting selection (a buy-box variant like the V2 header sets these);
      // absent on the original buy box, so it keeps its 'm3' / 'sub' default.
      if (window.ASPD_DEFAULT_VARIANT) this.variant = window.ASPD_DEFAULT_VARIANT;
      if (window.ASPD_DEFAULT_PLAN) this.plan = window.ASPD_DEFAULT_PLAN;
      this.initReveals(); this.initCounters(); this.initVariants(); this.initPlans();
      this.initQty(); this.updatePrice(); this.initBenefits(); this.initFaq();
      this.initCarousel(); this.initSlider(); this.initMagnetic(); this.initCart();
      this.initNav(); this.initNewsletter(); this.initBundles(); this.initGallery(); this.initCartCount();
    },

    /* header cart icon: refresh the count badge from the live cart (works even if the page was cached) */
    initCartCount: function () {
      if (DESIGN) return;
      var self = this;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.qa('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.style.display = c.item_count > 0 ? 'grid' : 'none'; }); })
        .catch(function () {});
    },

    /* product media gallery: swipeable slider + thumbnails + arrows (images & video) */
    initGallery: function () {
      this.qa('[data-gallery]').forEach(function (g) {
        if (g.__b) return; g.__b = 1;
        var track = g.querySelector('[data-gallery-track]'); if (!track) return;
        var slides = Array.prototype.slice.call(track.children);
        var prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
        var thumbs = Array.prototype.slice.call(g.parentNode.querySelectorAll('[data-gallery-thumb]'));
        var current = function () { return Math.round(track.scrollLeft / (track.clientWidth || 1)); };
        var go = function (i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
        var mark = function () { var c = current(); thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === c); }); };
        if (prev) prev.addEventListener('click', function () { go(current() - 1); });
        if (next) next.addEventListener('click', function () { go(current() + 1); });
        thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-gallery-thumb'), 10) || 0); }); });
        track.addEventListener('scroll', function () { clearTimeout(track.__st); track.__st = setTimeout(mark, 90); }, { passive: true });
        mark();
      });
    },

    /* bundles page: one-time / subscribe toggle + compact expandable rows */
    initBundles: function () {
      this.qa('[data-bundle]').forEach(function (grid) {
        var plan = grid.getAttribute('data-plan') || 'sub';
        var items = Array.prototype.slice.call(grid.querySelectorAll('[data-bundle-item]'));
        var sizeOpen = function () {
          items.forEach(function (item) {
            var panel = item.querySelector('[data-bundle-panel]'); if (!panel) return;
            var open = item.getAttribute('data-open') === '1';
            panel.style.maxHeight = open ? (panel.scrollHeight + 40) + 'px' : '0px';
            panel.style.opacity = open ? '1' : '0';
          });
        };
        var apply = function () {
          grid.setAttribute('data-plan', plan);
          Array.prototype.slice.call(grid.querySelectorAll('[data-bp], [data-bp-cta]')).forEach(function (el) {
            var key = el.getAttribute('data-bp') || el.getAttribute('data-bp-cta');
            if (key === plan) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
          });
          Array.prototype.slice.call(grid.querySelectorAll('[data-bundle-plan]')).forEach(function (btn) {
            var on = btn.getAttribute('data-bundle-plan') === plan;
            btn.style.background = on ? '#f3f2ee' : 'transparent';
            btn.style.color = on ? '#1b1712' : 'rgba(243,242,238,0.7)';
          });
          sizeOpen();
        };
        items.forEach(function (item) {
          if (item.__rowB) return; item.__rowB = 1;
          var row = item.querySelector('[data-bundle-row]');
          var chev = item.querySelector('[data-bundle-chev]');
          var setOpen = function (open) {
            item.setAttribute('data-open', open ? '1' : '0');
            var panel = item.querySelector('[data-bundle-panel]');
            if (panel) { panel.style.maxHeight = open ? (panel.scrollHeight + 40) + 'px' : '0px'; panel.style.opacity = open ? '1' : '0'; }
            if (chev) chev.style.transform = open ? 'rotate(45deg)' : 'rotate(0deg)';
          };
          if (row) row.addEventListener('click', function () { setOpen(item.getAttribute('data-open') !== '1'); });
          setOpen(item.getAttribute('data-open') === '1');
        });
        if (!grid.__bundleB) {
          grid.__bundleB = 1;
          Array.prototype.slice.call(grid.querySelectorAll('[data-bundle-plan]')).forEach(function (btn) {
            btn.addEventListener('click', function () { plan = btn.getAttribute('data-bundle-plan'); apply(); });
          });
          window.addEventListener('resize', sizeOpen);
        }
        apply();
      });
    },

    show: function (el) { el.style.opacity = '1'; el.style.transform = 'none'; },
    initReveals: function () {
      var self = this, els = this.qa('[data-reveal]').filter(function (e) { return !e.__r; });
      if (DESIGN || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.__r = 1; self.show(e); }); return; }
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (en.isIntersecting) { var el = en.target, d = parseInt(el.getAttribute('data-delay') || '0', 10); setTimeout(function () { self.show(el); }, d); io.unobserve(el); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      els.forEach(function (e) { e.__r = 1; io.observe(e); });
    },

    initCounters: function () {
      var self = this, els = this.qa('[data-count]').filter(function (e) { return !e.__c; });
      if (DESIGN || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.__c = 1; self.animateCount(e, true); }); return; }
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { self.animateCount(en.target); io.unobserve(en.target); } });
      }, { threshold: 0.5 });
      els.forEach(function (e) { e.__c = 1; io.observe(e); });
    },
    animateCount: function (el, instant) {
      var target = parseFloat(el.getAttribute('data-count'));
      var dec = el.getAttribute('data-dec') === '1', suffix = el.getAttribute('data-suffix') || '';
      var fmt = function (v) { return (dec ? v.toFixed(1) : Math.round(v).toLocaleString()) + suffix; };
      if (instant) { el.textContent = fmt(target); return; }
      var dur = 1500, start = performance.now();
      var step = function (now) { var p = Math.min((now - start) / dur, 1); p = 1 - Math.pow(1 - p, 3); el.textContent = fmt(target * p); if (p < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    },

    initVariants: function () {
      var self = this;
      this.qa('[data-variant]').forEach(function (c) { if (c.__b) return; c.__b = 1; c.addEventListener('click', function () { self.variant = c.getAttribute('data-variant'); self.applyVariants(); self.updatePrice(); }); });
      this.applyVariants();
    },
    applyVariants: function () {
      var self = this;
      this.qa('[data-variant]').forEach(function (c) {
        var on = c.getAttribute('data-variant') === self.variant;
        c.style.borderColor = on ? '#4b51c9' : 'rgba(20,18,13,0.12)';
        c.style.background = on ? 'rgba(75,81,201,0.09)' : 'rgba(255,255,255,0.5)';
        c.style.boxShadow = on ? '0 0 0 1.5px #4b51c9, 0 18px 44px -22px rgba(75,81,201,0.85)' : 'none';
        c.style.transform = on ? 'translateY(-2px)' : 'none';
      });
    },

    initPlans: function () {
      var self = this;
      this.qa('[data-plan]').forEach(function (c) { if (c.__b) return; c.__b = 1; c.addEventListener('click', function () { self.plan = c.getAttribute('data-plan'); self.applyPlans(); self.updatePrice(); }); });
      this.applyPlans();
    },
    applyPlans: function () {
      var self = this;
      this.qa('[data-plan]').forEach(function (c) {
        var on = c.getAttribute('data-plan') === self.plan;
        c.style.borderColor = on ? '#4b51c9' : 'rgba(20,18,13,0.12)';
        c.style.background = on ? 'rgba(75,81,201,0.09)' : 'rgba(255,255,255,0.5)';
        c.style.boxShadow = on ? '0 0 0 1.5px #4b51c9, 0 16px 40px -22px rgba(75,81,201,0.8)' : 'none';
        var dot = c.querySelector('[data-radio]');
        if (dot) { dot.style.borderColor = on ? '#4b51c9' : 'rgba(20,18,13,0.25)'; dot.style.boxShadow = on ? 'inset 0 0 0 4px #4b51c9' : 'none'; }
      });
    },

    initQty: function () {
      var self = this, dec = this.q('[data-qty-dec]'), inc = this.q('[data-qty-inc]');
      if (dec && !dec.__b) { dec.__b = 1; dec.addEventListener('click', function () { self.qty = Math.max(1, self.qty - 1); self.set('#qtyVal', self.qty); self.updatePrice(); }); }
      if (inc && !inc.__b) { inc.__b = 1; inc.addEventListener('click', function () { self.qty = Math.min(9, self.qty + 1); self.set('#qtyVal', self.qty); self.updatePrice(); }); }
    },

    /* Format integer cents using the shop's money format (window.ASPD_MONEY_FORMAT),
       so display always matches the store currency — same output as Liquid's `money` filter.
       Supports all Shopify amount placeholders, incl. the Swiss apostrophe format. */
    money: function (cents) {
      cents = Math.round(cents || 0);
      var fmt = this.moneyFormat || '€{{amount}}';
      function delim(num, precision, thousands, decimal) {
        var s = (num / 100).toFixed(precision);
        var parts = s.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
      var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), ph = m ? m[1] : 'amount', val;
      switch (ph) {
        case 'amount_no_decimals': val = delim(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': val = delim(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = delim(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': val = delim(cents, 2, "'", '.'); break;
        default: val = delim(cents, 2, ',', '.'); // 'amount' and any unknown
      }
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
    },

    updatePrice: function () {
      var p = this.prices[this.variant]; if (!p) return;
      var once = Math.round(+p.once), orig = Math.round(+p.orig);   // cents
      var hasPlan = (p.plan != null && p.sub != null);      // a real Shopify selling plan exists for this variant
      var pct = Math.max(0, Math.min(100, this.subPct || 0));
      var subUnit = hasPlan ? Math.round(+p.sub) : once;  // real selling-plan price; if no plan exists yet, no discount (one-time price)
      var pctShown = (hasPlan && once > 0) ? Math.round((1 - subUnit / once) * 100) : 0;
      var isSub = this.plan === 'sub';
      var unit = isSub ? subUnit : once;                    // the price the customer actually pays per item (cents)
      var save = orig > 0 ? Math.round((1 - unit / orig) * 100) : 0;   // headline saving vs compare-at
      var total = unit * this.qty;                          // reflects plan + packaging + quantity (cents)
      this.set('#pf-current', this.money(unit));
      this.set('#pf-orig', this.money(orig));
      this.set('#pf-save', aspdWord('save', 'SAVE') + ' ' + save + '%');
      this.set('#plan-once-price', this.money(once));
      this.set('#plan-sub-price', this.money(subUnit));
      this.set('#plan-sub-label', pctShown > 0 ? (aspdWord('subSave', 'Subscribe & Save') + ' ' + pctShown + '%') : aspdWord('subSave', 'Subscribe & Save'));
      this.set('#cart-total', aspdWord('addToCart', 'Add to cart') + ' · ' + this.money(total));
      // show each supply option's own price (in the selected plan) so every variant reads true
      var self = this;
      ['m1', 'm3', 'm6'].forEach(function (k) {
        var pp = self.prices[k]; if (!pp) return;
        var u = (isSub && pp.sub != null && !isNaN(pp.sub)) ? Math.round(+pp.sub) : Math.round(+pp.once);
        self.set('[data-card-price="' + k + '"]', self.money(u));
      });
      this.syncBuy();
    },

    /* keep the native product form's hidden inputs in sync with the current choice */
    syncBuy: function () {
      var map = window.ASPD_VARIANTS || {};
      var id = map[this.variant] || map.m3;
      var p = this.prices[this.variant] || {};
      var idEl = this.q('[data-buy-id]'), planEl = this.q('[data-buy-plan]'), qtyEl = this.q('[data-buy-qty]');
      if (idEl && id) idEl.value = id;
      if (planEl) planEl.value = (this.plan === 'sub' && p.plan != null) ? p.plan : '';
      var packUnits = (this.packUnits && this.packUnits[this.variant]) || 1;
      if (qtyEl) qtyEl.value = packUnits * this.qty;
    },

    initBenefits: function () {
      this.qa('[data-benefit]').forEach(function (card) {
        if (card.__b) return; card.__b = 1;
        var detail = card.querySelector('[data-benefit-detail]'), plus = card.querySelector('[data-benefit-plus]');
        card.addEventListener('click', function () {
          var open = card.getAttribute('data-open') === '1';
          card.setAttribute('data-open', open ? '0' : '1');
          if (detail) { detail.style.maxHeight = open ? '0px' : detail.scrollHeight + 'px'; detail.style.opacity = open ? '0' : '1'; detail.style.marginTop = open ? '0px' : '10px'; }
          if (plus) plus.style.transform = open ? 'rotate(0deg)' : 'rotate(45deg)';
          card.style.background = open ? 'rgba(255,255,255,0.5)' : 'rgba(75,81,201,0.07)';
          card.style.borderColor = open ? 'rgba(20,18,13,0.1)' : 'rgba(75,81,201,0.4)';
        });
      });
    },

    initFaq: function () {
      var items = this.qa('[data-faq]');
      items.forEach(function (item) {
        if (item.__b) return; item.__b = 1;
        var btn = item.querySelector('[data-faq-q]'), ans = item.querySelector('[data-faq-a]'), icon = item.querySelector('[data-faq-icon]');
        if (!btn || !ans) return;
        btn.addEventListener('click', function () {
          var open = item.getAttribute('data-open') === '1';
          var list = item.parentNode;
          Array.prototype.slice.call(list.querySelectorAll('[data-faq]')).forEach(function (o) {
            if (o !== item) { o.setAttribute('data-open', '0'); var a = o.querySelector('[data-faq-a]'), i = o.querySelector('[data-faq-icon]'); if (a) { a.style.maxHeight = '0px'; a.style.opacity = '0'; a.style.paddingBottom = '0px'; } if (i) i.style.transform = 'rotate(0deg)'; o.style.borderColor = 'rgba(20,18,13,0.1)'; o.style.background = 'rgba(255,255,255,0.5)'; }
          });
          item.setAttribute('data-open', open ? '0' : '1');
          ans.style.maxHeight = open ? '0px' : ans.scrollHeight + 40 + 'px';
          ans.style.opacity = open ? '0' : '1';
          ans.style.paddingBottom = open ? '0px' : '22px';
          if (icon) icon.style.transform = open ? 'rotate(0deg)' : 'rotate(45deg)';
          item.style.borderColor = open ? 'rgba(20,18,13,0.1)' : 'rgba(75,81,201,0.4)';
          item.style.background = open ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.7)';
        });
      });
    },

    initCarousel: function () {
      var self = this, track = this.q('[data-t-track]');
      if (!track || track.__b) return; track.__b = 1;
      var prev = this.q('[data-t-prev]'), next = this.q('[data-t-next]');
      var cards = Array.prototype.slice.call(track.children), n = cards.length;
      var apply = function () {
        if (!cards.length) return;
        var cw = cards[0].getBoundingClientRect().width, max = n - 1;
        self.tIndex = Math.max(0, Math.min(max, self.tIndex));
        track.style.transform = 'translateX(-' + (self.tIndex * (cw + 20)) + 'px)';
        if (prev) prev.style.opacity = self.tIndex === 0 ? '0.4' : '1';
        if (next) next.style.opacity = self.tIndex >= max ? '0.4' : '1';
      };
      if (prev) prev.addEventListener('click', function () { self.tIndex--; apply(); });
      if (next) next.addEventListener('click', function () { self.tIndex++; apply(); });
      window.addEventListener('resize', apply); apply();
    },

    initSlider: function () {
      var wrap = this.q('[data-slider]');
      if (!wrap || wrap.__b) return; wrap.__b = 1;
      var top = wrap.querySelector('[data-slider-top]'), handle = wrap.querySelector('[data-slider-handle]');
      if (!top || !handle) return;
      var apply = function (pct) { pct = Math.max(2, Math.min(98, pct)); top.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)'; handle.style.left = pct + '%'; };
      var fromEvent = function (e) { var r = wrap.getBoundingClientRect(); var cx = (e.touches ? e.touches[0].clientX : e.clientX); apply((cx - r.left) / r.width * 100); };
      var down = function (e) { fromEvent(e); var mv = function (ev) { ev.preventDefault(); fromEvent(ev); }; var up = function () { window.removeEventListener('pointermove', mv); window.removeEventListener('pointerup', up); }; window.addEventListener('pointermove', mv); window.addEventListener('pointerup', up); };
      wrap.addEventListener('pointerdown', down); apply(52);
    },

    initMagnetic: function () {
      if (window.matchMedia && window.matchMedia('(pointer:coarse)').matches) return;
      this.qa('[data-magnetic]').forEach(function (btn) {
        if (btn.__mag) return; btn.__mag = 1;
        btn.addEventListener('pointermove', function (e) { var r = btn.getBoundingClientRect(); var mx = e.clientX - r.left - r.width / 2, my = e.clientY - r.top - r.height / 2; btn.style.transform = 'translate(' + (mx * 0.22) + 'px,' + (my * 0.32) + 'px)'; });
        btn.addEventListener('pointerleave', function () { btn.style.transform = 'translate(0,0)'; });
      });
    },

    initCart: function () {
      var self = this;
      // cosmetic ripple on the button (distinct flag so it never collides with magnetic/form binding)
      this.qa('[data-cart]').forEach(function (btn) {
        if (btn.__rip) return; btn.__rip = 1;
        btn.addEventListener('click', function (e) {
          var r = btn.getBoundingClientRect(); var rip = document.createElement('span'); var size = Math.max(r.width, r.height) * 2.2;
          rip.style.cssText = 'position:absolute;border-radius:50%;background:rgba(255,255,255,0.4);pointer-events:none;transform:scale(0);transition:transform .6s ease,opacity .6s ease;width:' + size + 'px;height:' + size + 'px;left:' + ((e.clientX || 0) - r.left - size / 2) + 'px;top:' + ((e.clientY || 0) - r.top - size / 2) + 'px;';
          btn.appendChild(rip); requestAnimationFrame(function () { rip.style.transform = 'scale(1)'; rip.style.opacity = '0'; }); setTimeout(function () { rip.remove(); }, 650);
        });
      });
      // enhance the NATIVE product form: fetch-add then jump to checkout; native submit is the fallback
      var form = this.q('#aspd-buy-form');
      if (!form || form.__b) return; form.__b = 1;
      form.addEventListener('submit', function (e) {
        if (DESIGN) { e.preventDefault(); self.toast('Add-to-cart is disabled in the editor preview'); return; }
        e.preventDefault();
        self.syncBuy();
        var idEl = form.querySelector('[data-buy-id]'), planEl = form.querySelector('[data-buy-plan]'), qtyEl = form.querySelector('[data-buy-qty]');
        var id = idEl && idEl.value; if (!id) { self.toast('Please choose an option'); return; }
        if (form.__busy) return; form.__busy = true;
        var item = { id: id, quantity: (qtyEl && parseInt(qtyEl.value, 10)) || 1 };
        if (planEl && planEl.value) item.selling_plan = planEl.value;
        self.toast('Adding to cart…');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (r) {
            if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'add failed');
            form.__busy = false;
            self.toast('✓ Added to cart');
            self.initCartCount();   // refresh header cart badge; STAY on the page (no checkout redirect)
          })
          .catch(function () { form.__busy = false; form.submit(); });   // fallback: native form POST → cart (still not checkout)
      });

      // "Buy now": make the cart hold exactly the current selection, then go straight to checkout.
      // Fix 2026-11-01: a plain /cart/add.js ADDED another unit on every tap, so a shopper who
      // went back and tapped again reached checkout at double the price. replaceInCart() keeps
      // one line for this buy box, and adds nothing when that exact line is already there.
      var buyNow = this.q('[data-buynow]');
      if (buyNow && !buyNow.__b) {
        buyNow.__b = 1;
        // A page restored from the back/forward cache keeps its JS state, so without this the
        // busy flag set before leaving for checkout would leave the button dead on return.
        window.addEventListener('pageshow', function (ev) { if (ev.persisted) buyNow.__busy = false; });
        buyNow.addEventListener('click', function () {
          if (DESIGN) { self.toast('Checkout is disabled in the editor preview'); return; }
          self.syncBuy();
          var bId = form.querySelector('[data-buy-id]'), bPlan = form.querySelector('[data-buy-plan]'), bQty = form.querySelector('[data-buy-qty]');
          var id = bId && bId.value; if (!id) { self.toast('Please choose an option'); return; }
          if (buyNow.__busy) return; buyNow.__busy = true;
          var item = { id: id, quantity: (bQty && parseInt(bQty.value, 10)) || 1 };
          if (bPlan && bPlan.value) item.selling_plan = bPlan.value;
          var dest = self.redirect || '/checkout';
          self.toast('Taking you to checkout…');
          self.replaceInCart(item)
            .then(function () { window.location.href = dest; })
            .catch(function () { buyNow.__busy = false; self.toast('Something went wrong, please try again'); });
        });
      }
    },

    /* Make the cart hold exactly `item` for THIS buy box, then resolve.
       "This buy box" = the variant ids in window.ASPD_VARIANTS, one per pack, even where the
       packs are separate products. Shipping insurance and other products are not in that set,
       so they are never touched.
         - exactly `item` already there (same variant, quantity and plan): add nothing
         - otherwise: zero this buy box's lines by line key via /cart/update.js (fires no
           AddToCart), then ONE /cart/add.js for `item` (one AddToCart, as before)
       Zeroing comes first because /cart/add.js MERGES into an existing line with the same
       variant and plan, which would make the quantity wrong. */
    replaceInCart: function (item) {
      var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      var map = window.ASPD_VARIANTS || {};
      var ours = {};
      Object.keys(map).forEach(function (k) { if (map[k]) ours[String(map[k])] = 1; });
      ours[String(item.id)] = 1;
      var wantPlan = item.selling_plan ? String(item.selling_plan) : '';
      var planOf = function (it) {
        var a = it.selling_plan_allocation;
        return String((a && a.selling_plan && a.selling_plan.id) || '');
      };
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart read failed'); return r.json(); })
        .then(function (cart) {
          var mine = (cart.items || []).filter(function (it) { return ours[String(it.variant_id)]; });
          var exact = mine.length === 1
            && String(mine[0].variant_id) === String(item.id)
            && mine[0].quantity === item.quantity
            && planOf(mine[0]) === wantPlan;
          if (exact) return null;
          var cleared = Promise.resolve();
          if (mine.length) {
            var u = {};
            mine.forEach(function (it) { u[it.key] = 0; });
            cleared = fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ updates: u }) })
              .then(function (r) { if (!r.ok) throw new Error('cart clear failed'); });
          }
          return cleared.then(function () {
            return fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: [item] }) })
              .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
              .then(function (r) {
                if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'add failed');
              });
          });
        });
    },
    toast: function (msg) {
      var t = document.getElementById('aspd-toast');
      if (!t) { t = document.createElement('div'); t.id = 'aspd-toast'; t.style.cssText = 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(20px);z-index:200;background:rgba(10,11,18,0.92);color:#f3f2ee;padding:14px 22px;border-radius:100px;font-family:Manrope,sans-serif;font-weight:600;font-size:14px;border:1px solid rgba(124,131,239,0.5);box-shadow:0 20px 50px -20px rgba(75,81,201,0.9);opacity:0;transition:all .4s cubic-bezier(0.16,1,0.3,1);backdrop-filter:blur(12px)'; document.body.appendChild(t); }
      t.textContent = msg; requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
      clearTimeout(this._tt); this._tt = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(20px)'; }, 2400);
    },

    /* fixed nav: announcement scrolls away, nav pins to top (page-wide, editor-safe) */
    initNav: function () {
      var ann = this.q('#aspd-announce'), nav = this.q('#aspd-nav'), sp = this.q('#aspd-nav-spacer');
      if (!nav) return;
      // Horizon scrolls inside .page-wrapper only at >=990px; below that the window
      // scrolls and .page-wrapper.scrollTop stays 0. Read whichever is actually
      // scrolling and subscribe to both, so the fixed nav tracks scroll on desktop
      // AND mobile (and across resizes).
      var getY = function () {
        var w = document.querySelector('.page-wrapper');
        return Math.max(window.pageYOffset || 0, (document.documentElement && document.documentElement.scrollTop) || 0, (w && w.scrollTop) || 0);
      };
      var subscribe = function (fn) {
        window.addEventListener('scroll', fn, { passive: true });
        var w = document.querySelector('.page-wrapper');
        if (w) w.addEventListener('scroll', fn, { passive: true });
      };
      var annH = function () { return (ann && ann.offsetParent !== null) ? ann.offsetHeight : 0; };
      var place = function () {
        if (sp) sp.style.height = nav.offsetHeight + 'px';
        var y = getY();
        nav.style.top = Math.max(0, annH() - y) + 'px';
        if (y > 40) { nav.style.background = 'rgba(6,7,12,0.82)'; nav.style.boxShadow = '0 10px 40px -20px rgba(0,0,0,0.8)'; }
        else { nav.style.background = 'rgba(6,7,12,0.55)'; nav.style.boxShadow = 'none'; }
      };
      place();
      if (!nav.__b) {
        nav.__b = 1;
        subscribe(place);
        window.addEventListener('resize', place); window.addEventListener('load', place);
        if (window.ResizeObserver) { try { new ResizeObserver(place).observe(nav); if (ann) new ResizeObserver(place).observe(ann); } catch (e) {} }
      }
    },

    initNewsletter: function () {
      this.qa('[data-newsletter]').forEach(function (form) {
        if (form.__b) return; form.__b = 1;
        // real Shopify customer form posts normally; only fake (no method) forms are intercepted
        if (form.getAttribute('data-fake') === '1') { form.addEventListener('submit', function (e) { e.preventDefault(); var msg = form.parentNode.querySelector('[data-newsletter-msg]'); if (msg) msg.style.opacity = '1'; form.reset(); }); }
      });
    }
  };

  function boot() { App.boot(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', function () { App.initReveals(); });
  window.ASPD = App;
})();

